<template>
  <Universities />
</template>

<script>
import Universities from '@/components/admin/Universities.vue'

export default {
  name: 'AdministrationUniversities',
  components: { Universities }
}
</script>

<style scoped>

</style>
